// extracted by mini-css-extract-plugin
export var integrations = "integrations-module--integrations--mWj0U";